<template>
  <b-button
    :variant="variant"
    :disabled="disabled || loading"
    @click="$emit('click', $event)"
  >
    <slot v-if="!loading" />
    <div v-else>
      Uploading...
      <b-spinner small />
    </div>
  </b-button>
</template>

<script lang="ts">

import Vue from 'vue'
import Component from 'vue-class-component'

const props = {
  variant: {
    type: String,
    default: null,
  },
  disabled: Boolean,
  loading: Boolean,
}

@Component
export default class SaveImageButton extends Vue.extend({ props }) {}

</script>
